import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { ConfigPedidoDadosBasicos } from 'pages/compra/configuracao-pedido/types';

/**
 * Formata os dados iniciais da step de dados básicos.
 */
export const formatInitialDadosBasicosData = (data: ConfigPedidoDadosBasicos) => {
    const { dtInicioVigencia, dtFimVigencia } = data || {};

    data.dtInicioVigencia = `${dtInicioVigencia}T00:00:00`;
    data.dtFimVigencia = `${dtFimVigencia}T00:00:00`;

    return data;
};

export function useQueryDadosBasicos() {
    const { id } = useParams();
    const { setStepDisabled } = useConfigPedidoStepContext();
    const requestListagem = useRequestListagem();

    return useQuery<ConfigPedidoDadosBasicos>({
        enabled: Boolean(id),
        queryKey: ['config-pedido-dados-basicos', id],
        queryFn: () =>
            requestListagem({ url: `/gestao/configpedido/${id}` }).then((res) => {
                const { data } = res.data;
                const { idTipoControleEstoquePedido } = data.tipoControleEstoquePedido || {};
                const { idTipoPedido } = data.tipoPedido || {};

                setStepDisabled('importarEstoque', idTipoControleEstoquePedido !== 2);
                setStepDisabled('sazonal', idTipoPedido !== 4);

                return formatInitialDadosBasicosData(res.data.data);
            }),
    });
}
